module.exports = __webpack_public_path__ + "static/media/tab_process.ac18fab2.png";